import React, { useEffect, useRef, useState } from 'react';

interface RevealProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Blendet Inhalte beim Scrollen sanft ein – langsam und gleitend,
 * passend zum ruhigen Charakter des Segelflugs. Läuft genau einmal.
 * Bei prefers-reduced-motion greift die globale Transition-Abschaltung
 * aus index.css, der Inhalt erscheint dann sofort.
 */
const Reveal: React.FC<RevealProps> = ({ children, className = '' }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    if (!('IntersectionObserver' in window)) {
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      // Im sichtbaren Zustand bewusst KEINE transform-Klasse: ein transformierter
      // Vorfahre würde position:fixed bei Nachfahren (z. B. Lightbox) brechen
      className={`transition-all duration-700 ease-out ${
        visible ? 'opacity-100' : 'opacity-0 translate-y-6'
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default Reveal;
